import React from "react";
import styled from "styled-components";

const colorMap = (p) => ({
	white: {
		color: p.theme.white,
		text: p.theme.black,
	},
	black: {
		color: p.theme.black,
		text: p.theme.white,
	},
	transparent: {
		color: "transparent",
		text: p.theme.white,
		border: true,
	},
});

const StyledInput = styled.input`
	${p => p.icon && `padding-left: ${3 - 0.2}em;`}
	${p => p.fullWidth && "width: 100%;"}
	${
		p => {
			const o = colorMap(p)[p.flavor.toLowerCase()];

			return `
				background-color: ${o.color};
				color: ${o.text};
				&:placeholder {
					color: ${o.text};
					opacity: 0.5;
				}
				${o.border && `box-shadow: inset 0 0 0 2px ${o.text};`}
			`;
		}
	}
`;

const Input = (props) => {
	const { name, valid, required, fullWidth, icon, label, message, flavor, style, ...other } = props;

	return (
		<OuterWrapper
			valid = { valid }
			style = { style }
		>
			{ label && <label>{ label }</label> }
			<InputWrapper>
				{
				props.icon
				&& <Icon
					type = { props.icon }
					color = { colorMap(props)[props.flavor.toLowerCase()].text }
					input
				/>
			}
				<StyledInput
					name = { name }
					required = { required }
					flavor = { flavor }
					fullWidth = { fullWidth }
					icon = { !!icon }
					{ ...other }
				/>
			</InputWrapper>
			<Message>
				{ message }
			</Message>
		</OuterWrapper>
	);
};

Input.propTypes = {
	flavor: React.PropTypes.oneOf([
		"BLACK",
		"WHITE",
		"TRANSPARENT",
	]),
	fullWidth: React.PropTypes.bool,
	icon: React.PropTypes.oneOf(icons),
	label: React.PropTypes.string,
	message: React.PropTypes.string,
	name: React.PropTypes.string.isRequired,
	onChange: React.PropTypes.func.isRequired,
	onBlur: React.PropTypes.func,
	placeholder: React.PropTypes.string,
	required: React.PropTypes.bool,
	type: React.PropTypes.oneOf([
		"EMAIL",
		"PASSWORD",
		"TEXT",
	]),
	valid: React.PropTypes.bool,
	value: React.PropTypes.string,
};

Input.defaultProps = {
	flavor: "WHITE",
};

const OuterWrapper = styled.div`
	
`;

const InputWrapper = styled.div`
	position: relative;
`;


const Message = styled.div`

`;

export default Input;
